import { useSelector } from 'react-redux';

import { getWebview } from '@cian/webview/webview';

import { selectIsMyHome, selectIsWebview } from '../../../selectors/page';
import * as React from 'react';

/**
 * Если страницу отчета открыли как подробную аналитику из проекта "Мой дом"
 * дополнительно сразу пушим в историю текущий урл (нужно чтобы по клику на браузерную
 * кнопку назад не было мигания пока андройд закрывает вебвью)
 * При клике (свайпе) на браузерную назад - пушим экшен в андройд, по которому
 * вебвью закрывается (логика внутри андройд апп)
 */
export function useCustomPopHistory() {
  const isMyHome = useSelector(selectIsMyHome);
  const isWebview = useSelector(selectIsWebview);

  React.useEffect(() => {
    if (isMyHome && isWebview) {
      const webview = getWebview();

      window.addEventListener('popstate', () => {
        webview.sendAction({ action: 'goToMyHomeListing' });
      });

      window.addEventListener('beforeunload', () => {
        webview.sendAction({ action: 'goToMyHomeListing' });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
